module.exports = __webpack_public_path__ + "files/c4fd3570849f3cb9543c0deb90650045.svg";